import { createActionConstants } from './actionsHelper';
export const MediaActionTypes = {
  ...createActionConstants('MEDIA_DATA'),
  ...createActionConstants('TAGS_DATA'),
  ...createActionConstants('GENERATE_URL')
};

export const RESET_MAGAZINE_URL = 'RESET_MAGAZINE_URL';

const getParams = ({
  app: {
    value: { key, publisherId }
  },
  allCategories,
  autoLocale,
  language,
  country,
  categories,
  tag
}) => {
  let payload = { key, publisherId };
  if (autoLocale) {
    payload.locale = 'AUTO';
  } else {
    payload = {
      ...payload,
      language: language.value,
      countryCode: country.value
    };
    if (!allCategories && (categories || tag)) {
      if (tag) {
        payload.tag = tag;
      } else if (categories && categories.length !== 0) {
        payload.category = categories.map(({ value }) => value).join(',');
      } else {
        payload.locale = 'AUTO';
      }
    }
  }
  return { ...payload, isDesktop: false };
};

export function fetchMediaData(key, publisherId) {
  return {
    type: MediaActionTypes.MEDIA_DATA_REQUESTED,
    payload: { key, publisherId }
  };
}

export function fetchTagsData(key, publisherId) {
  return {
    type: MediaActionTypes.TAGS_DATA_REQUESTED,
    payload: { key, publisherId }
  };
}

export function generateUrl(data) {
  return {
    type: MediaActionTypes.GENERATE_URL_REQUESTED,
    payload: getParams(data)
  };
}

export function resetMagazineURL() {
  return {
    type: RESET_MAGAZINE_URL
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/mediaActions.js